import { FC, useState, useEffect } from 'react'

import { useDataContext } from '../contexts'
import { LearningLabsViews, getLearningLabsView, getGroupedModules, isLab } from '../Reporting'

import { LLModuleProfile } from '../interfaces/ModuleTypes'

import { LoadingIndicator } from '.'
import { TileView } from './dataview'
import { PrimaryHeader } from '../styles/Styles'

const LearningLabs: FC = () => {
    const { allProfiles } = useDataContext()
    const [dataViews, setDataViews] = useState<LearningLabsViews>()

    const labProfiles: LLModuleProfile[] = allProfiles.filter(isLab)

    useEffect(() => {
        if (!labProfiles.length || dataViews) return

        const groupedModules = getGroupedModules<LLModuleProfile>(labProfiles)
        const overall = getLearningLabsView(labProfiles)

        setDataViews({ overall, groupedModules })

    }, [dataViews, labProfiles])

    if (!dataViews) return <LoadingIndicator loading={true} timeout={250} />
    return (
        <>
            <PrimaryHeader variant={'h4'}>
                {`Learning Labs Data`}
            </PrimaryHeader>
            <TileView dataTiles={dataViews.overall} />
            {
                dataViews.groupedModules.map((lab, index) => <TileView key={'lltv' + index} title={lab.moduleName} dataTiles={getLearningLabsView(lab.profiles)} />)
            }
        </>
    )
}

export default LearningLabs
